import { Component } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { AdminService } from '../../../../admin.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ResponsibleService } from '@shared/services/responsible.service';
import { SnackService } from '@shared/services/snack.service';
import { IResponsible, IResponsibleUser, IUpdateResponsible, ResponsibleType } from '@shared/interfaces';
import { SortAlphabeticallyPipe } from '@shared/pipes';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-responsible-edit',
    templateUrl: './admin-responsible-edit.component.html',
    styleUrls: ['./admin-responsible-edit.component.scss'],
    providers: [SortAlphabeticallyPipe],
    standalone: false
})
export class AdminResponsibleEditComponent extends AdminActionsDirective {
    ResponsibleType = ResponsibleType;
    formGroup: UntypedFormGroup;

    constructor(
        private fb: UntypedFormBuilder,
        private responsibleService: ResponsibleService,
        private snack: SnackService,
        private aSortPipe: SortAlphabeticallyPipe,
        adminService: AdminService,
        dialogService: DialogService,
        moduleService: ModuleService
    ) {
        super(adminService, dialogService, moduleService);
        this.buildForm();
    }

    get item(): IUpdateResponsible {
        return this.formGroup.value as IUpdateResponsible;
    }

    get formerItem(): IResponsible {
        return this.selectedItem;
    }

    get previousUsers(): IResponsibleUser[] {
        return [...(this.formerItem.responsible || []), ...(this.formerItem.specialists || [])];
    }

    async saveItem(event: any): Promise<void> {
        const submitter: HTMLButtonElement = event.submitter;

        if (submitter) {
            submitter.disabled = true;
        }

        this.formGroup.markAllAsTouched();
        if (this.formGroup.valid) {
            try {
                const item: IUpdateResponsible = this.formGroup.getRawValue();

                const result = await this.responsibleService.updateItem(item);
                this.snack.openSnackBarSuccess(
                    `Responsible item ${result.orgDescription} - ${result.orgCode} updated successfully.`
                );
                this.goToResponsible(result);
            } catch (e) {
                this.snack.openSnackBarError(e.error.message);
            }
        } else {
            this.snack.openSnackBarError('Please check your input.');
        }

        if (submitter) {
            submitter.disabled = false;
        }
    }

    get excludedUsers(): IResponsibleUser[] {
        return [
            ...(this.item.mainResponsible || []),
            ...(this.item.mainSpecialists || []),
            ...(this.item.otherResponsible || []),
            ...(this.item.otherSpecialists || [])
        ];
    }

    changeAssignedCountries(event: string[]) {
        this.aSortPipe.transform(event);
    }

    private buildForm() {
        this.formGroup = this.fb.group({
            id: this.formerItem.id,
            title: this.formerItem.orgDescription,
            code: this.formerItem.orgCode,
            mainResponsible: [(this.formerItem.responsible || []).filter(e => e.fullAccess), Validators.required],
            mainSpecialists: [(this.formerItem.specialists || []).filter(e => e.fullAccess), Validators.required],
            otherResponsible: [(this.formerItem.responsible || []).filter(e => !e.fullAccess)],
            otherSpecialists: [(this.formerItem.specialists || []).filter(e => !e.fullAccess)],
            responsibleType: this.formerItem.responsibleType,
            assignedCountries: [this.aSortPipe.transform(this.formerItem.assignedCountries) || []]
        });
    }
}
